import { createAsyncThunk } from "@reduxjs/toolkit";

import { postUserConfirmation } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

type UserConfirmationPayload = {
  otp?: string;
  encryptedUserId?: string;
  confirmationToken?: string;
};

export const saveUserConfirmation = createAsyncThunk(
  "userConfirmation/saveUserConfirmation",
  async (otp: string, { getState, rejectWithValue }) => {
    try {
      const { adapter, registrations } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { token } = fetchAuthToken(getState());

      const userId = registrations?.registrations?.id;

      const response = await postUserConfirmation(token, baseUrl, userId, {
        otp
      });

      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const handleEmailConfirmation = createAsyncThunk(
  "userConfirmation/handleEmailConfirmation",
  async (payload: UserConfirmationPayload, { getState, rejectWithValue }) => {
    try {
      const { adapter } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { token } = fetchAuthToken(getState());
      const userId = payload.encryptedUserId;
      const confirmationToken = payload?.confirmationToken;

      const response = await postUserConfirmation(token, baseUrl, userId, {
        confirmationToken
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
